import React from "react";

export default function WarningIcon() {
  return <i className="fa fa-warning" style={{ color: `var(--buttercup)` }} />;
}
WarningIcon.displayName = "WarningIcon";
